import List from '../List';

function GroupedList({
    items = [],
    onSelect
}) {
    if (!items.length){
        return null;
    }

    return (
        <>
            {items.map((item) => (
                <div key={item.uid} className="mb-3">
                    <div>
                        <h4 className="text-muted">{item.title}</h4>
                    </div>
                    
                    <List
                        items={item.items}
                        onSelect={onSelect}
                    />
                </div>
            ))}
        </>
    );
};

export default GroupedList;
